<template>
	<div>
		<div
			class="content"
			name="box-top"
			id="printArea"
			:style="{
				backgroundColor: `rgba(255,255,255,${bandingstyle.appearance.bgOpacity / 100})`,
				marginTop: isBank ? '150px' : '0'
			}"
		>
			<div class="previewFunction" v-if="isBank">
				<div class="print" title="打印" v-print="print"></div>
				<div class="derive" title="导出" @click="exportData"></div>
			</div>
			<div class="body" ref="printer" id="printArea">
				<div class="pageHeader" v-if="bandingstyle.appearance.headerState == 1">
					<div class="pageHeaderText" :style="{ backgroundColor: bandingstyle.appearance.headerBgcolor }" v-if="bandingstyle.appearance.headerType == 0">
						<div
							:style="{
								fontSize: bandingstyle.appearance.titleSize + 'px',
								color: bandingstyle.appearance.headerColor,
								fontWeight: bandingstyle.appearance.headerBold,
								fontStyle: bandingstyle.appearance.headerItalic,
								textDecoration: bandingstyle.appearance.headerUnderline,
								textAlign: bandingstyle.appearance.headerAlign
							}"
						>
							{{ bandingstyle.appearance.headerContent }}
						</div>
					</div>

					<div v-else-if="bandingstyle.appearance.headerType == 1"><img style="width: 100%; height: auto" :src="bandingstyle.appearance.headerImg" /></div>
				</div>
				<div class="logo" v-if="bandingstyle.appearance.logoSet" :style="{ textAlign: bandingstyle.appearance.logoLocation }">
					<img class="logo-img" :src="bandingstyle.appearance.logoSet" />
				</div>
				<div class="ques_box">
					<div class="header" :style="{ borderColor: bandingstyle.subjectColor }" v-if="page == 0 && data.title">
						<p
							class="title"
							v-if="bandingstyle.appearance.displayTitle != 0"
							:style="{
								fontSize: bandingstyle.appearance.fontTitleSize + 'px',
								color: bandingstyle.appearance.fontTitleColor,
								fontWeight: bandingstyle.appearance.fontTitleBold,
								fontStyle: bandingstyle.appearance.fontTitleItalic,
								textDecoration: bandingstyle.appearance.fontTitleUnderline
							}"
						>
							<HtmlClickImgEnlarge :content="data.title" />
						</p>
						<div class="countDown-box" v-if="quanxian.ifPageAnswerTime == 1">
							<!-- 倒计时 -->
							<CountDown :endTime="endTime" :endText="$t('UserAnswer.IsOver')" @examendChange="examendChange"></CountDown>
						</div>
						<p
							class="welcome-words"
							v-if="bandingstyle.appearance.displayWelcome != 0"
							:style="{
								fontSize: bandingstyle.appearance.fontWelcomeSize + 'px',
								color: bandingstyle.appearance.fontWelcomeColor,
								fontWeight: bandingstyle.appearance.fontWelcomeBold,
								fontStyle: bandingstyle.appearance.fontWelcomeItalic,
								textDecoration: bandingstyle.appearance.fontWelcomeUnderline
							}"
						>
							<HtmlClickImgEnlarge :content="data.depict" />
						</p>
					</div>
					<template v-if="list && list.length > 0">
						<div v-for="(item, index) in list" :key="index">
							<!-- 单选题 -->
							<SelectType
								v-if="
									(item.questionsTypeId == '8' || item.questionsTypeId == '10' || item.questionsTypeId == '12' || item.questionsTypeId == '9') &&
										item.isShow &&
										item.bindIsShow
								"
								:data="item"
								:bandingstyle="bandingstyle"
								@userAnswerChange="userAnswerChange"
							></SelectType>

							<!-- 手机号  单行输入框  多行输入框 填空题  多项填空 横向填空 -->
							<ShortAnswer
								v-else-if="
									(item.questionsTypeId == '2' ||
										item.questionsTypeId == '3' ||
										item.questionsTypeId == '4' ||
										item.questionsTypeId == '5' ||
										item.questionsTypeId == '34' ||
										item.questionsTypeId == '35' ||
										item.questionsTypeId == '37') &&
										item.isShow &&
										item.bindIsShow
								"
								:data="item"
								:bandingstyle="bandingstyle"
								@userAnswerChange="userAnswerChange"
							></ShortAnswer>

							<!-- 拖拽排序 星级评分 -->
							<OtherQuestionsPC
								v-else-if="
									(item.questionsTypeId == '14' ||
										item.questionsTypeId == '11' ||
										item.questionsTypeId == '13' ||
										item.questionsTypeId == '15' ||
										item.questionsTypeId == '16' ||
										item.questionsTypeId == '17' ||
										item.questionsTypeId == '25' ||
										item.questionsTypeId == '33' ||
										item.questionsTypeId == '6' ||
										item.questionsTypeId == '38') &&
										item.isShow &&
										item.bindIsShow
								"
								:data="item"
								:bandingstyle="bandingstyle"
								@userAnswerChange="userAnswerChange"
							></OtherQuestionsPC>
							<!-- 矩阵题型 -->
							<MatrixTypePC
								v-else-if="
									(item.questionsTypeId == '19' ||
										item.questionsTypeId == '20' ||
										item.questionsTypeId == '21' ||
										item.questionsTypeId == '22' ||
										item.questionsTypeId == '39') &&
										item.isShow &&
										item.bindIsShow
								"
								:data="item"
								:bandingstyle="bandingstyle"
								@userAnswerChange="userAnswerChange"
							></MatrixTypePC>
							<!-- 级联题 -->
							<cascadePC
								v-else-if="item.questionsTypeId == '36' && item.isShow && item.bindIsShow"
								:data="item"
								:bandingstyle="bandingstyle"
								@userAnswerChange="userAnswerChange"
							></cascadePC>
						</div>
					</template>

					<div class="no-more" v-else-if="list && list.length == 0">{{$t('UserAnswer.NothingInTheWorld')}}</div>
					<div class="btn-box">
						<!-- 暂存 -->
						<div style="margin-top:10px">
							<el-button 
								v-if="quanxian.isStaging == 1" 
								@click="stagingClick" 
								size="medium" 
								type="primary"
								:style="{ backgroundColor: bandingstyle.subjectColor, borderColor: bandingstyle.subjectColor }"
							>
								{{$t('UserAnswer.Staging')}}
							</el-button>
							<!-- 提交 -->
							<el-button
								v-if="iSSubmit || page == lists.length - 1"
								@click="submit()"
								size="medium"
								type="primary"
								:disabled="list && list.length == 0"
								:style="{ backgroundColor: bandingstyle.subjectColor, borderColor: bandingstyle.subjectColor }"
							>
								{{ bandingstyle.appearance.buttonContent ? bandingstyle.appearance.buttonContent : $t('UserAnswer.SubmitTo') }}
							</el-button>
						</div>
						<div v-if="lists.length > 1 && list && list[0].questionsTypeId == '26'" class="page-btn">
							<!-- 上一页 -->
							<el-button
								size="medium"
								:style="{ backgroundColor: bandingstyle.subjectColor, borderColor: bandingstyle.subjectColor }"
								v-if="list[0].lastBtnShow"
								@click="lastPage"
								type="primary"
							>
								{{ list[0].lastBtnText }}
							</el-button>
							<!-- 下一页 -->
							<el-button
								:style="{ backgroundColor: bandingstyle.subjectColor, borderColor: bandingstyle.subjectColor }"
								size="medium"
								v-if="!iSSubmit && page != lists.length - 1"
								:loading="nextPageLiad"
								@click="nextPage"
								type="primary"
							>
								{{ nextPageTime > 0 ? nextPageTime : list[0].nextBtnText }}
							</el-button>
						</div>
					</div>
				</div>
			</div>

			<div class="share" v-if="data.title">
				<p class="title">{{$t('UserAnswer.ScanQRCodeToAnswerQuestions')}}</p>
				<div class="qrCode" style=""><canvas ref="qrCodeImg" class="qrCode-img"></canvas></div>
			</div>
		</div>

		<div class="report-box">
			<div class="support">
				<p v-if="quanxian.copyrightConfig && quanxian.copyrightConfigContent">{{ quanxian.copyrightConfigContent }}</p>
				<p>{{$t('UserAnswer.DongfangAixueProvidesSupport')}}</p>
			</div>
		</div>
	</div>
</template>

<script>
import CountDown from '@/components/countDown';
import SelectType from './selectTypePC.vue';
import ShortAnswer from './shortAnswerPC.vue';
import OtherQuestionsPC from './otherQuestionsPC.vue';
import MatrixTypePC from './matrixTypePC.vue';
import cascadePC from './cascadePC.vue';
import HtmlClickImgEnlarge from '@/components/myComponents/htmlClickImgEnlarge.vue'
import { setMatrixRows } from '../../js/userAnswer/setMatrixRows/setMatrixRows.js';
import QrCode from 'qrcode';
import { ClearAnswer } from '../../js/userAnswer/ClearAnswer';
import { Verification } from '../../js/userAnswer/Verification';
export default {
	components: {
		SelectType,
		ShortAnswer,
		OtherQuestionsPC,
		MatrixTypePC,
		CountDown,
		cascadePC,
		HtmlClickImgEnlarge
	},
	name: 'appearancePC',
	props: {
		bandingstyle: {},
		data: {},
		quanxian: {},
		quotaList: [],
		isBank: {
			type: Boolean,
			default: false // true 题库预览
		},
		isStaging: {
			type: Boolean,
			default: false // true 暂存 使用本地的试题信息
		},
	},
	data() {
		return {
			//打印
			print: {
				id: 'printArea',
				popTitle: this.$t('UserAnswer.Print'), // 打印配置页上方标题
				extraHead: '', // 最上方的头部文字，附加在head标签上的额外标签,使用逗号分隔
				preview: '', // 是否启动预览模式，默认是false（开启预览模式，可以先预览后打印）
				previewTitle: '', // 打印预览的标题（开启预览模式后出现）,
				previewPrintBtnLabel: '', // 打印预览的标题的下方按钮文本，点击可进入打印（开启预览模式后出现）
				zIndex: '', // 预览的窗口的z-index，默认是 20002（此值要高一些，这涉及到预览模式是否显示在最上面）
				clickMounted: value => {
					// 去掉 点击展开
					let titleid = document.getElementsByClassName('content');
					console.log('titleid :>> ', titleid);
					console.log(titleid[0].style.width);
					// titleid[0].style.width = '1200px'
					// titleid[0].style.marginLeft = '600px'
					//     for (var i = 0; i < titleid.length; i++) {
					//       titleid[i].style.display = 'none';
					//     }

					//     this.groupJson.forEach((item, index) => {
					//       // console.log(item)
					//       if (item.ifSetPrint) {
					//         if (item.ifSetPrint == true) {
					//           let printId = document.getElementById(item.id);
					//           console.log(printId);
					//           if (printId != null) {
					//             printId.style.display = 'block';
					//           }
					//         } else {
					//           let printId = document.getElementById(item.id);
					//           console.log(printId);
					//           if (printId != null) {
					//             printId.style.display = 'none';
					//           }
					//         }
					//       } else {
					//         let printId = document.getElementById(item.id);
					//         console.log(printId);
					//         if (printId != null) {
					//           printId.style.display = 'none';
					//         }
					//       }
					//     });
				}, // 点击打印按钮的回调函数
				previewBeforeOpenCallback: value => {
					console.log('预览窗口打开之前的callback');
				}, // 预览窗口打开之前的callback（开启预览模式调用）
				previewOpenCallback: value => {
					console.log('预览窗口打开之后的callback');
				}, // 预览窗口打开之后的callback（开启预览模式调用）
				beforeOpenCallback: value => {
					console.log('开启打印前的回调事件');
				}, // 开启打印前的回调事件
				openCallback: value => {
					console.log('调用打印之后的回调事件');
				}, // 调用打印之后的回调事件
				closeCallback: value => {
					let titleid = document.getElementsByClassName('content');
					console.log(titleid[0].style.width);
					// titleid[0].style.width = '650px'
					// titleid[0].style.marginLeft = '0px'
					// let titleid = document.getElementsByClassName('titleHeader');
					// for (var i = 0; i < titleid.length; i++) {
					//   titleid[i].style.display = 'block';
					//   titleid[i].style.padding = '0px 20px';
					//   titleid[i].style.height = '50px';
					//   titleid[i].style.backgroundColor = '#f4f5f9';
					//   titleid[i].style.lineHeight = '50px';
					//   titleid[i].style.display = 'flex';
					//   titleid[i].style.justifyContent = 'space-between';
					//   titleid[i].style.marginBottom = '20px';
					// }
					// console.log('关闭打印的回调事件');
					// this.groupJson.forEach(item => {
					//   let printId = document.getElementById(item.id);
					//   if (printId != null) {
					//     printId.style.display = 'block';
					//   }
					// });
				}, // 关闭打印的回调事件（无法确定点击的是确认还是取消）
				url: '',
				standard: '',
				extraCss: ''
			},
			//打印  end
			input: '',
			radio: '',
			checkList: [],
			textarea: '',
			exam: {},
			endTime: '',
			lists: [],
			list: [],
			page: 0,
			percentage: 0,
			id: '',
			SignaturePad: null,
			config: {
				penColor: '#000000', //笔刷颜色
				minWidth: 1, //最小宽度
				maxWidth: 3,
				backgroundColor: '#f7f8fa'
			},
			nextPageLiad: false,
			nextPageTime: 0,
			nextPageTimer: {},
			lastPageTime: 0,
			lastPageTimer: {},
			iSSubmit: false // 是否显示下一页 提交按钮
		};
	},
	computed: {
		// 答题中收集配额试题列表
		quotatypeList() {
			// console.log(this.quotaList)
			let data = this.quotaList.filter(info => {
				return info.ruleType == 1;
			});

			return data;
		}
	},
	watch: {
		lists: {
			handler(newV, oldV) {
				let count = 0;
				let quesAnswerNum = 0;
				this.data.questionsList.forEach((info, index) => {
					if (info.questionsTypeId != '25' && info.questionsTypeId != '26') {
						count++;
						if (info.questionsTypeId != '10' && info.userAnswer) {
							// console.log(info.userAnswer)
							quesAnswerNum++;
						} else if (info.questionsTypeId == '10' && info.userAnswerArr && info.userAnswerArr.length > 0) {
							quesAnswerNum++;
						}
					}
				});
				this.percentage = parseInt((quesAnswerNum / count) * 100);

				if (this.quanxian && this.quanxian.saveLastContent == 1) {
					localStorage.setItem(this.id, JSON.stringify(this.data.questionsList));
				}
			},
			deep: true
			// immediate: true
		},
		page: {
			handler(newV, oldV) {
				// console.log('page触发了');
				this.setPageTime();
			},
			immediate: true
		},
		// 外观设置页面需要实时看到设置结果
		'bandingstyle.appearance.displayQuestionsno': {
			handler(newV, oldV) {
				this.data.questionsList = this.data.questionsList.map((info, index) => {
					let reg = /^([0-9]*、|<p>[0-9]*、)+/;
					if (!reg.test(info.questionsName)) {
						let quesIndex = '';
						if (this.bandingstyle.appearance.displayQuestionsno == 1) {
							quesIndex = info.quesIndex >= 0 ? info.quesIndex : '';
						}
						info.questionsName = this.pTagAddStyle(info.questionsName, quesIndex, info.mustanswer);
					} else {
						if (this.bandingstyle.appearance.displayQuestionsno == 0) {
							info.questionsName = info.questionsName.replace(reg, '')
						}
					}
					return info;
				});
			},
			deep: true,
			immediate: true
		},
	},
	created() {
		this.id = this.getQueryStringhash('id');
		// 权限start
		// 获取考试结束倒计时
		if (this.quanxian && this.quanxian.ifPageAnswerTime == 1) {
			let nowTime = new Date().getTime();
			this.endTime = nowTime + this.quanxian.pageAnswerTime * 60 * 1000;
			this.endTime = this.endTime.toString();
		}
		// 权限end

		this.getList('created');
		this.displayLogic();
		
		// 初始化试题脚本中属性bindIsShow
		this.data.questionsList = setMatrixRows(this.data.questionsList)
	},
	mounted() {
		let url = window.location.href;
		// console.log(url)
		QrCode.toCanvas(this.$refs.qrCodeImg, url, {
			width: 100,
			height: 100
		});
		// 监听高级脚本中的跳转逻辑
		const unwatch = this.$watch('data.questionsList', {
			handler(newValue, oldV) {
				console.log('///////////////////////');
				this.getList()
			},
			deep: true
		});
	},
	methods: {
		exportData() {
			let that = this;
			let params = {
				that: this,
				url: `${this.$config.service.exportWjWrod}`,
				method: 'POST',
				data: {
					surveyId: this.id
				},
				cb(res) {
					console.log('查询全部全部字段对照', res);
					if (res.code == 0) {
						that.popUpPrompt()
					} else {
						that.$message.error(res.message);
					}
				}
			};
			this.$util.request(params);
		},		
		popUpPrompt() {
			this.$notify({
				dangerouslyUseHTMLString: true,
				message: `${this.$t('DataRecycling.DataPreparationInProgress')} 
							<a href="#" class="notify-link" id="my-download-link">
								<span style="color: blue;">${this.$t('DataRecycling.MyDownload')}</span>
							</a> 
							${this.$t('DataRecycling.CanViewProgress')}`
			});
			this.$nextTick(() => {
				const link = document.querySelector('#my-download-link');
				if (link) {
					link.addEventListener('click', (e) => {
						e.preventDefault(); // 阻止默认的链接跳转
						this.$router.push('/MyProject'); // 使用 Vue Router 跳转
					});
				}
			});
		},
		setPageTime() {
			if (this.list) {
				this.list.forEach(info => {
					if (info.questionsTypeId == '26') {
						if (info.minTimeSwitch) {
							this.nextPageLiad = true;
							this.nextPageTime = info.minTime;
							this.nextPageTimer = setInterval(() => {
								if (this.nextPageTime > 0) {
									this.nextPageTime--;
								}
								// console.log(this.nextPageTime)
								if (this.nextPageTime == 0) {
									this.nextPageLiad = false;
									clearInterval(this.nextPageTimer);
								}
							}, 1000);
						}
						if (info.maxTimeSwitch) {
							this.lastPageTime = info.maxTime;
							this.lastPageTimer = setInterval(() => {
								if (this.lastPageTime > 0) {
									this.lastPageTime--;
								}
								if (this.lastPageTime == 0) {
									this.nextPage(true);
									clearInterval(this.lastPageTimer);
								}
							}, 1000);
						}
					}
				});
			}
		},
		pTagAddStyle(questionsName, quesIndex, mustanswer) {
			let reg = /<p[^>]*>/;
			let result = reg.exec(questionsName);
			let htmlstr = '';
			if (result) {
				if (typeof quesIndex == 'number') {
					result = `${result}${quesIndex + 1}、`;
				} else {
					result = `${result}`;
				}
				htmlstr = questionsName.replace(/<p[^>]*>/, result);
			} else {
				if (typeof quesIndex == 'number') {
					htmlstr = `${quesIndex + 1}、${questionsName}`;
				} else {
					htmlstr = `${questionsName}`;
				}
			}
			return htmlstr;
		},
		// 获取试题分页后list
		getList(state) {
			let arr = [],
				list = [],
				lists = [];
			this.data.questionsList.forEach((info, index) => {
				if (info.questionsTypeId == '26' && info.isShow && index == 0) {
					arr.push(info);
				} else if (info.questionsTypeId == '26' && info.isShow && index != 0) {
					lists.push(arr);
					arr = [];
					arr.push(info);
				} else {
					arr.push(info);
				}
				if (index == this.data.questionsList.length - 1) {
					lists.push(arr);
				}
				if (state == 'created') {
					let quesIndex = '';
					if (this.bandingstyle.appearance.displayQuestionsno == 1) {
						quesIndex = info.quesIndex >= 0 ? info.quesIndex : '';
					}
				}
			});
			list = lists[this.page];
			this.list = list;
			this.lists = lists;
			if (state == 'created') {
				this.setPageTime();
			}
			// console.log(this.lists)
			// console.log(this.list)
		},
		// 答题后任何条件
		anyItem(type, data) {
			let actionIndex = 0,
				toJumpQuesIndex = 0,
				isAnswered = false;
			if ((data.userAnswer != undefined && data.userAnswer != '') || (data.userAnswerArr && data.userAnswerArr.length > 0)) {
				// 已答
				isAnswered = true;
			} else {
				isAnswered = false;
			}
			this.data.questionsList.forEach((info, index) => {
				if (info.qid == data.qid) {
					actionIndex = index;
				}
				if (type == info.qid) {
					toJumpQuesIndex = isAnswered ? index : 0;
				} else if (type == 'end') {
					toJumpQuesIndex = isAnswered ? index + 1 : 1;
				}
			});
			this.data.questionsList.forEach((info, index) => {
				if (actionIndex < index) {
					info.isShow = true;
				}
				if (type == 'endD' && isAnswered) {
					if (actionIndex < index) {
						info.isShow = false;
						if (info.userAnswer) {
							info.userAnswer = '';
						} else {
							info.userAnswerArr = [];
						}
					}
					if (this.page == this.lists.length - 1) {
						this.iSSubmit = true;
					}
					this.submit(true, 4);
				} else if (type != 'endD' && isAnswered) {
					if (actionIndex < index && toJumpQuesIndex > index) {
						info.isShow = false;
						if (info.userAnswer) {
							info.userAnswer = '';
						} else {
							info.userAnswerArr = [];
						}
					}
				}
				this.getList();
			});
		},
		/**
		 * 当选择某一项 跳转到某一题时
		 * @param type 要跳转到的试题id
		 * @param data 当前试题对象
		 * @param bandLastTestindex 隐藏当前下标以下的试题（复合条件会涉及）
		 */
		anItem(type, data, bandLastTestindex) {
			let toJumpQuesIndex = this.data.questionsList.length;
			this.data.questionsList.forEach((info, index) => {
				if (info.qid == data.qid && bandLastTestindex == -1) {
					bandLastTestindex = index;
				}
				if (type == info.qid) {
					toJumpQuesIndex = index;
				}
			});

			// console.log(actionIndex)
			// console.log(toJumpQuesIndex)
			this.data.questionsList.forEach((info, index) => {
				if (bandLastTestindex <= index) {
					info.isShow = true;
				}
				if (bandLastTestindex < index && toJumpQuesIndex > index) {
					info.isShow = false;
					if (info.userAnswer) {
						info.userAnswer = '';
					} else {
						info.userAnswerArr = [];
					}
				}
				this.iSSubmit = false;
				// console.log('//找到题型')
				this.getList();
			});
			// console.log(this.data.questionsList)
		},
		/**
		 * 当选择某一项 提前结束时
		 * @param data 当前试题对象
		 * @param bandLastTestindex 隐藏当前下标以下的试题（复合条件会涉及）
		 */
		endDItem(data, bandLastTestindex) {
			this.data.questionsList.forEach((info, index) => {
				if (info.qid == data.qid && bandLastTestindex == -1) {
					bandLastTestindex = index;
				}
			});
			this.data.questionsList.forEach(async (info, index) => {
				if (bandLastTestindex < index) {
					info.isShow = false;
					if (info.userAnswer) {
						info.userAnswer = '';
					} else {
						info.userAnswerArr = [];
					}
					await this.getList();
					if (this.page == this.lists.length - 1) {
						this.iSSubmit = true;
					}
				}
				this.submit(true, 4);
			});
		},
		// 当前题目以后的试题全部显示
		noEvents(data) {
			let actionIndex = 0;
			this.data.questionsList.forEach((info, index) => {
				if (info.qid == data.qid) {
					actionIndex = index;
				}
			});
			this.data.questionsList.forEach((info, index) => {
				if (actionIndex < index) {
					info.isShow = true;
					this.getList();
				}
			});
		},
		// 判断其中试题答案是否符合条件
		isCanJump(conditionItem, info) {
			let result = false,
				isAnswered = false;
			if (!info.isShow || !info.bindIsShow) return true
			if (info.userAnswer || (info.userAnswerArr && info.userAnswerArr.length > 0)) {
				isAnswered = true;
			} else {
				isAnswered = false;
			}
			if (info.questionsTypeId == '38') {
				switch (conditionItem.sizeRangeType) {
					case 1:
						if (parseInt(info.userAnswer) == parseInt(conditionItem.startNum)) {
							result = true;
						}
						break;
					case 2:
						if (parseInt(info.userAnswer) > parseInt(conditionItem.startNum)) {
							result = true;
						}
						break;
					case 3:
						if (parseInt(info.userAnswer) < parseInt(conditionItem.startNum)) {
							result = true;
						}
						break;
					case 4:
						if (parseInt(info.userAnswer) > parseInt(conditionItem.startNum) && parseInt(info.userAnswer) < parseInt(conditionItem.endNum)) {
							result = true;
						}
						break;
				}
				return result;
			}
			if (conditionItem.optionId != 1 && isAnswered) {
				if (
					(info.userAnswer && info.userAnswer.indexOf(conditionItem.optionId) != -1) ||
					(info.userAnswerArr && info.userAnswerArr.indexOf(conditionItem.optionId) != -1)
				) {
					// 答案与条件匹配
					// console.log(1)
					result = true;
				}
			} else if (conditionItem.optionId == 1 && isAnswered) {
				// 任意选项（有答案）
				// console.log(2)
				result = true;
			}
			return result;
		},
		// 当试题存在逻辑，用户答题后触发
		userAnswerChange(data) {
			// 跳转
			let setting = data.logicalSettings;
			if (setting) {
				this.jumpQuestion(setting, data);
			}
			// 选项关联 试题是否显示
			this.displayLogic(data);
			// 配额收集
			this.quotaCollection(data);

			// 矩阵行显示逻辑
			this.data.questionsList = setMatrixRows(this.data.questionsList)
			// 多选题、图片多选最大选择项数量限制
			if (data.questionsTypeId == '10' || 
				(data.questionsTypeId == '6' && data.cutType == 8)
			) {
				this.maxOptionNumVerify(data)
			}
		},
		// 多选类最大选择项数量限制
		maxOptionNumVerify(data) {
			if (data.userAnswerArr.length > 0) {
				if (data.maxOptionsNum != 0 && data.userAnswerArr.length >= data.maxOptionsNum) {
					data.validateMsg = `请最多选择${data.maxOptionsNum}个选项`;
					data.validate = true;
				} else {
					data.validate = false;
				}
			}
		},
		jumpQuestion(setting, data) {
			// console.warn(setting)
			if (setting.jump.type == 0) {
				// 答完题即可触发
				if (setting.jump.logicList.length > 0) {
					this.anyItem(setting.jump.logicList[0].questionId, data);
				}
			} else {
				// console.log('需要复原题型')
				this.noEvents(data);
				// console.log(setting.jump.logicList)
				this.iSSubmit = setting.jump.logicList.length > 0 ? false : this.iSSubmit;

				setting.jump.logicList.forEach((info, index) => {
					// console.log(info)
					/**
					 * num 满足条件的个数
					 * andOr 复核条件的类型
					 * qidIsSame 当前的复合条件时否为同一个试题上的
					 * bandLastTestindex 复核复合条件的最后一道题（跳转试题使用）
					 */
					let num = 0,
						andOr = 1,
						qidIsSame = false,
						bandLastTestindex = -1;

					if (info.condition.length > 1) {
						// 存在复合条件
						let qid = info.condition[0].qid;
						qidIsSame = info.condition.every(item => item.qid == qid);
					}
					info.condition.forEach((item, CIndex) => {
						// console.log(item)
						andOr = item.andOr;
						// 如果是复合条件 查询其他试题是否复核条件
						// console.log(`qidIsSame:${qidIsSame}`)
						if (!qidIsSame) {
							this.data.questionsList.forEach((info, index) => {
								if (item.qid == info.qid) {
									if (index > bandLastTestindex) {
										bandLastTestindex = index;
									}
									if (this.isCanJump(item, info)) num++;
								}
							});
						} else {
							// 判断其中试题答案是否符合条件
							if (this.isCanJump(item, data)) num++;
						}
					});
					// andOr： 1 且 2 或
					// console.log(`andOr:${andOr}`)
					// console.log(`num:${num}`)
					// console.log(`info.condition.length:${info.condition.length}`)
					if ((andOr == 1 && num == info.condition.length) || (andOr == 2 && num > 0)) {
						// jump
						if (info.questionId != 'endD') {
							// console.log('跳转到某题')
							console.log(`bandLastTestindex:${bandLastTestindex}`);
							this.anItem(info.questionId, data, bandLastTestindex);
						} else {
							// console.log('直接提交')
							this.endDItem(data, bandLastTestindex);
						}
					}
				});
			}
		},
		// 获取该题已选的option
		getOption(data) {
			return data.optionList.filter(op => {
				if (data.userAnswer && data.userAnswer == op.oid) {
					op.qid = data.qid;
					op.inputValue = '';
					return op;
				}
				if (data.userAnswerArr && data.userAnswerArr.indexOf(op.oid) !== -1) {
					op.qid = data.qid;
					op.inputValue = '';
					return op;
				}
			});
		},
		// 被关联的试题 清除answer
		clearAnswer(question) {
			if (question.userAnswerArr) {
				let oidArr = question.optionList.map(val => val.oid);
				let i = question.userAnswerArr.findIndex(val => oidArr.indexOf(val) == -1);
				if (i !== -1) question.userAnswerArr.splice(i, 1);
			}
			if (question.userAnswer) {
				let i = question.optionList.findIndex(val => question.userAnswer == val.oid);
				// console.log(i)
				if (i === -1) question.userAnswer = '';
			}
		},
		displayLogic(data) {
			let activeQuesIndex = 0;
			let { questionsList } = this.data;
			if (data != undefined) {
				for (let j = 0; j < questionsList.length; j++) {
					if (data.qid == questionsList[j].qid) {
						activeQuesIndex = j;
					}
					// 选项关联
					if (data.associated && data.associated.indexOf(questionsList[j].qid) !== -1) {
						if (data.questionsTypeId == '10') {
							// 获取当前试题已选的option
							let newOptionList = this.getOption(data);
							// 保留不是当前试题的option
							let actionOptionList = questionsList[j].optionList.filter(info => data.qid != info.qid);
							questionsList[j].optionList = [...newOptionList, ...actionOptionList];

							// 如果被关联的试题 已答并选项被清除 清除答案
							this.clearAnswer(questionsList[j]);
						} else {
							// 获取当前试题已选的option
							let newOptionList = this.getOption(data);
							// 保留不是当前试题的option
							let actionOptionList = questionsList[j].optionList.filter(info => data.qid != info.qid);
							questionsList[j].optionList = [...newOptionList, ...actionOptionList];

							// 如果被关联的试题 已答并选项被清除 清除答案
							this.clearAnswer(questionsList[j]);
						}
					}
				}
			}
			this.setQuestonName(data);
			for (let j = 0; j < questionsList.length; j++) {
				// console.log('j, activeQuesIndex :>> ', j, activeQuesIndex);
				if (j >= activeQuesIndex) {
					// 试题是否显示
					this.bindIsShow(questionsList[j]);
				}
			}
		},
		quotaCollection(data) {
			// console.log(data)
			for (let i in this.quotatypeList) {
				// console.log(this.quotatypeList[i])
				if (this.quotatypeList[i].rlueConditionOne == data.qid) {
					// 当前选中的答案为配额第一项
					if (data.userAnswer) {
						// 当前试题答案为字符串
						this.quotaAnswer(this.quotatypeList[i], data.userAnswer, 1);
					} else if (data.userAnswerArr) {
						// 当前试题答案为数组对象
						this.quotaAnswerArr(this.quotatypeList[i], data.userAnswerArr, 1);
					}
				} else if (this.quotatypeList[i].rlueConditionTwo == data.qid) {
					// 当前选中的答案为配额第二项
					if (data.userAnswer) {
						// 当前试题答案为字符串
						this.quotaAnswer(this.quotatypeList[i], data.userAnswer, 2);
					} else if (data.userAnswerArr) {
						// 当前试题答案为数组对象
						this.quotaAnswerArr(this.quotatypeList[i], data.userAnswerArr, 2);
					}
				}
			}
		},
		//IF userAnswer
		quotaAnswer(info, answer, number) {
			// 条件列表
			for (let i in info.questionnaireNewQuotaDetailsList) {
				let data = info.questionnaireNewQuotaDetailsList[i];
				// optionOneCondition 配额选项1 、optionTwoCondition配额选项2
				// console.log(data.quotaNumber);
				if (data.quotaNumber > 0) {
					if (number == 1 && answer == data.optionOneCondition) {
						if (info.ruleConditionTwoType == 1) {
							// 样本配额
							// console.warn('立即提交 state为77');
							let ruleText = info.ruleText ? ruleText : this.$t('UserAnswer.QuotaIsFull');
							this.getQuotaInfo(data.id, ruleText);
							break;
						} else {
							this.validateQuota(info, data, 1);
							break;
						}
					} else if (number == 2 && answer == data.optionTwoCondition) {
						if (info.ruleConditionOneType == 1) {
							// 样本配额
							// console.warn('立即提交 state为76');
							let ruleText = info.ruleText ? ruleText : this.$t('UserAnswer.QuotaIsFull');
							this.getQuotaInfo(data.id, ruleText);
						} else {
							this.validateQuota(info, data, 2);
							break;
						}
					}
				}
			}
		},
		//IF userAnswerArr
		quotaAnswerArr(info, answerArr, number) {
			// number: 配额中的第几个试题
			// info: typelistinfo
			// 条件列表
			for (let i in info.questionnaireNewQuotaDetailsList) {
				let data = info.questionnaireNewQuotaDetailsList[i];
				// optionOneCondition 配额选项1 、optionTwoCondition配额选项2
				// console.log(data.quotaNumber);
				if (data.quotaNumber > 0) {
					if (number == 1 && answerArr.indexOf(data.optionOneCondition) !== -1) {
						if (info.ruleConditionTwoType == 1) {
							// 样本配额
							// console.warn('立即提交 state为78');
							let ruleText = info.ruleText ? ruleText : this.$t('UserAnswer.QuotaIsFull');
							this.getQuotaInfo(data.id, ruleText);
							break;
						} else {
							this.validateQuota(info, data, 1);
							break;
						}
					} else if (number == 2 && answerArr.indexOf(data.optionTwoCondition) !== -1) {
						if (info.ruleConditionOneType == 1) {
							// 样本配额
							// console.warn('立即提交 state为79');
							let ruleText = info.ruleText ? ruleText : this.$t('UserAnswer.QuotaIsFull');
							this.getQuotaInfo(data.id, ruleText);
						} else {
							this.validateQuota(info, data, 2);
							break;
						}
					}
				}
			}
		},
		// 判断配额是否满了
		getQuotaInfo(id, tip) {
			let that = this;
			let params = {
				that: this,
				url: `${this.$config.service.verifyQuota}`,
				method: 'POST',
				data: {
					id: id
				},
				cb(res) {
					// console.log(res);
					if (res.code == 0) {
						if (res.resultBody == 1) {
							that.submit(true, 14, tip);
						}
					}
				}
			};
			params.isnologin = true;
			this.$util.request(params);
		},
		// 验证配额
		validateQuota(obj, objItem, number) {
			let ruleText = obj.ruleText ? obj.ruleText : this.$t('UserAnswer.QuotaIsFull');
			// number：配中的第几个选项
			let resilt = false;
			// console.log(this.quotaList)
			for (let el in this.quotaList) {
				// console.log(obj.id)
				// console.log(this.quotaList[el].id)
				if (this.quotaList[el].id == obj.id) {
					// 可以确定是哪个配额
					for (let quotaIndex in this.quotaList[el].questionnaireNewQuotaDetailsList) {
						let val = this.quotaList[el].questionnaireNewQuotaDetailsList[quotaIndex];
						if (val.quotaNumber > 0) {
							if (objItem.optionTwoCondition) {
								if (objItem.optionTwoCondition == val.optionTwoCondition) {
									if (number == 1) {
										if (obj.rlueConditionTwo) {
											for (let j in this.data.questionsList) {
												if (this.data.questionsList[j].userAnswer && this.data.questionsList[j].userAnswer == val.optionTwoCondition) {
													// console.warn('立即提交 state为71');
													this.getQuotaInfo(val.id, ruleText);
													resilt = true;
													break;
												} else if (
													this.data.questionsList[j].userAnswerArr &&
													this.data.questionsList[j].userAnswerArr.indexOf(val.optionTwoCondition) !== -1
												) {
													// console.warn('立即提交 state为72');
													this.getQuotaInfo(val.id, ruleText);
													resilt = true;
													break;
												}
											}
										}
									} else if (number == 2) {
										// console.log('obj')
										// console.log(obj)
										if (obj.rlueConditionOne) {
											for (let j in this.data.questionsList) {
												if (this.data.questionsList[j].userAnswer && this.data.questionsList[j].userAnswer == val.optionOneCondition) {
													// console.warn('立即提交 state为74');
													this.getQuotaInfo(val.id, ruleText);
													resilt = true;
													break;
												} else if (
													this.data.questionsList[j].userAnswerArr &&
													this.data.questionsList[j].userAnswerArr.indexOf(val.optionOneCondition) !== -1
												) {
													// console.warn('立即提交 state为75');
													this.getQuotaInfo(val.id, ruleText);
													resilt = true;
													break;
												}
											}
										}
									}
								}
							} else {
								// console.warn('立即提交 state为73');
								this.getQuotaInfo(objItem.id, ruleText);
								resilt = true;
								break;
							}
						}
						if (resilt) {
							break;
						}
					}
					if (resilt) {
						break;
					}
				}
				if (resilt) {
					break;
				}
			}
		},
		setQuestonName(data) {
			let quesTypeArr = ['6', '8', '9', '10', '12', '2', '3', '4', '5'];
			this.data.questionsList.forEach(info => {
				let Reg = /\<span class=\"ques[0-9]\">(.*?)<\/span>/g;
				let spanArr = info.questionsName ? info.questionsName.match(Reg) : [];
				if (spanArr) {
					spanArr.forEach(el => {
						if (data && el.match(/ques(\S*)"/)[1] == data.quesIndex + 1) {
							if (quesTypeArr.indexOf(data.questionsTypeId) !== -1) {
								if (data.userAnswer) {
									// 分组
									if (data.groupingOptionList.length > 0) {
										// console.log(data.groupingOptionList)
										data.groupingOptionList.forEach(group => {
											group.optionList.forEach(option => {
												if (option.oid == data.userAnswer) {
													info.questionsName = info.questionsName.replace(el, `<span class="ques${data.quesIndex + 1}">${option.labelName}</span>`);
												}
											});
										});
									}
									if (data.optionList.length > 0) {
										data.optionList.forEach(val => {
											if (val.oid == data.userAnswer) {
												info.questionsName = info.questionsName.replace(el, `<span class="ques${data.quesIndex + 1}">${val.labelName}</span>`);
											}
										});
									} else {
										info.questionsName = info.questionsName.replace(el, `<span class="ques${data.quesIndex + 1}">${data.userAnswer}</span>`);
									}
								} else if (data.userAnswerArr && data.userAnswerArr.length > 0) {
									let str = '';
									// 分组
									data.groupingOptionList.forEach(group => {
										group.optionList.forEach(val => {
											data.userAnswerArr.forEach(el => {
												if (val.oid == el) {
													str = str + val.labelName;
												}
											});
										});
									});
									data.optionList.forEach(val => {
										data.userAnswerArr.forEach(el => {
											if (val.oid == el) {
												str = str + val.labelName;
											}
										});
									});
									info.questionsName = info.questionsName.replace(el, `<span class="ques${data.quesIndex + 1}">${str}</span>`);
								}
							}
						}
					});
				}
			});
		},
		// 绑定该题的试题是否显示
		bindIsShow(ques, data) {
			// console.log('绑定')
			// console.log('ques.logicalSettings :>> ', ques.logicalSettings);
			try{
				if (ques.logicalSettings) {
					if (!ques.logicalSettings.show.length) {
						ques.logicalSettings.show = []
					}
					ques.logicalSettings.show.forEach(info =>{
						if (!info) return
						let bindIsShowArr = []; // 当需要满足全部条件时
						let showObj = info;
						let questionState = false;
						let bindIsShowNum = 0;
						if (showObj.condition == 1) {
							if (showObj.conditionList.length > 0) {
								this.data.questionsList.forEach(el => {
									showObj.conditionList.forEach((info, index) => {
										if (info.questionId == el.qid) {
											// console.log('符合条件')
											questionState = this.isQuestionState(info.questionState, info.optionId, el, info);
											bindIsShowArr[index] = questionState;
										}
									});
								});
							}
							// console.log(`是否符合条件arr：${bindIsShowArr}`)
							bindIsShowArr.forEach(val => {
								if (val) {
									bindIsShowNum++;
								}
							});
							if (bindIsShowNum == bindIsShowArr.length) {
								ques.bindIsShow = true;
							} else {
								ques.bindIsShow = false;
								ques = ClearAnswer(ques)
							}
						} else if (showObj.condition == 2) {
							if (showObj.conditionList.length > 0) {
								showObj.conditionList.forEach((info, index) => {
									bindIsShowArr.push(false);
								});
								this.data.questionsList.forEach(el => {
									showObj.conditionList.forEach((info, index) => {
										if (info.questionId == el.qid) {
											questionState = this.isQuestionState(info.questionState, info.optionId, el, info);
											bindIsShowArr[index] = questionState;
										}
									});
								});
							}
							bindIsShowArr.forEach(val => {
								if (val) {
									bindIsShowNum++;
								}
							});
							if (bindIsShowNum > 0) {
								ques.bindIsShow = true;
							} else {
								ques.bindIsShow = false;
								ques = ClearAnswer(ques)
							}
						}
					})
				}
			}catch (error){
				console.log('error :>> ', error);
			}
		},
		isQuestionState(state, optionId, data, info) {
			let result = false;
			switch (state) {
				case 1:
					// 选中
					if (data.questionsTypeId == '8' || data.questionsTypeId == '12') {
						if (optionId == 0 && data.userAnswer) {
							result = true;
						} else if (optionId != 0 && data.userAnswer.indexOf(info.optionId) != -1) {
							result = true;
						}
					} else if (data.questionsTypeId == '10' || data.questionsTypeId == '19') {
						// console.log(data.userAnswerArr)
						// console.log(info.questionId)
						if (optionId == 0 && data.userAnswerArr.length > 0) {
							result = true;
						} else if (optionId != 0 && data.userAnswerArr.indexOf(info.optionId) != -1) {
							result = true;
						}
					}
					break;
				case 2:
					// 未选中
					if (data.questionsTypeId == '8' || data.questionsTypeId == '12') {
						if (optionId == 0 && data.userAnswer == '') {
							result = true;
						} else if (optionId != 0 && data.userAnswer.indexOf(info.optionId) == -1) {
							result = true;
						}
					} else if (data.questionsTypeId == '10' || data.questionsTypeId == '19') {
						// console.log(data.userAnswerArr)
						// console.log(info.optionId)
						if (optionId == 0 && data.userAnswerArr.length == 0) {
							result = true;
						} else if (optionId != 0 && data.userAnswerArr.indexOf(info.optionId) == -1) {
							result = true;
						}
					}
					break;
				case 3:
					// 显示
					if (data.isShow && data.bindIsShow) {
						result = true;
					}
					break;
				case 4:
					// 不显示
					// console.log('不显示')
					if (!data.isShow || !data.bindIsShow) {
						result = true;
					}
					break;
				case 5:
					// 等于
					if (parseInt(data.userAnswer) == parseInt(info.startNum)) {
						result = true;
					}
					break;
				case 6:
					// 大于
					if (parseInt(data.userAnswer) > parseInt(info.startNum)) {
						result = true;
					}
					break;
				case 7:
					// 小于
					if (parseInt(data.userAnswer) < parseInt(info.startNum)) {
						result = true;
					}
					break;
				case 8:
					// 介于
					if (parseInt(data.userAnswer) > parseInt(info.startNum) && parseInt(data.userAnswer) < parseInt(info.endNum)) {
						result = true;
					}
					break;
			}
			return result;
		},
		getCanvas(qid) {
			var canvas = document.querySelector(`.canvasId${qid}`);
			this.signaturePad = new SignaturePad(canvas, this.config);
			canvas.height = 190;
			canvas.width = 438;
		},
		saveCanvasId(item) {
			if (this.signaturePad.isEmpty() == false) {
				item.userAnswer = this.signaturePad.toDataURL();
			} else {
				item.userAnswer = '';
			}
		},
		clearCanvasId(item) {
			this.signaturePad.clear();
			item.userAnswer = '';
		},
		stagingClick() {
			this.$emit('submit', 3, this.$t('UserAnswer.SuccessfullyStaged'));
		},
		submit(state, answerState, ruleText) {
			// 验证
			let { goAnchorName, result } = Verification(this.list)
			// console.log('state :>> ', state);
			// console.log('result :>> ', result);
			// return
			if (state == true || result == false) {
				console.log('验证')
				this.$emit('submit', answerState, ruleText);
			} else if (result){
				this.goAnchor(goAnchorName)
			}
		},
		lastPage() {
			this.page--;
			this.list = this.lists[this.page];
			this.goAnchor('box-top', 'start');
		},
		nextPage(state) {
			// state 为true跳过验证
			// 验证
			let { goAnchorName, result } = Verification(this.list)
			if (state && this.page == this.lists.length - 1) {
				this.submit(true);
			} else {
				if (state == true || result == false) {
					this.page++;
					this.list = this.lists[this.page];
					for (let j = 0; j < this.data.questionsList.length; j++) {
						this.setQuestonName(this.data.questionsList[j]);
					}
					this.goAnchor('box-top', 'start');
				} else if (result){
					this.goAnchor(goAnchorName)
				}
			}
		},
		goAnchor(aname, block = 'center') {
			this.$nextTick(() => {
				let selector = `div[name=${aname}]`;
				var anchor = this.$el.querySelector(selector);
				if (anchor) {
					anchor.scrollIntoView({ block: block, behavior: 'smooth' });
				}
			});
		},
		examendChange() {
			// console.log('考试结束了')
			this.$emit('addEventListener', 1);
		},

		// 获取参数 带#
		getQueryStringhash(key) {
			let after = window.location.hash.split('?')[1];
			if (after) {
				let reg = new RegExp('(^|&)' + key + '=([^&]*)(&|$)');
				let r = after.match(reg);
				if (r != null) {
					return decodeURIComponent(r[2]);
				} else {
					return null;
				}
			}
		}
	},
	beforeDestroy() {
		clearInterval(this.nextPageTimer);
		clearInterval(this.lastPageTimer);
	}
};
</script>
<style lang="scss" scoped>
@media (max-width: 1200px) {
	.share {
		display: none;
	}
	.content {
		width: 700px;
	}
}
@media (min-width: 1200px) {
	.content {
		width: 900px;
	}
}
.content {
	border-radius: 10px;
	// width: 650px;
	background-color: #fff;
	box-sizing: border-box;
	margin: 0 auto;
	position: relative;
	// margin-left:600px;
	.previewFunction {
		width: 60px;
		height: 130px;
		background-color: #ffffff;
		position: absolute;
		top: 150px;
		left: -70px;
		display: flex;
		flex-direction: column;
		align-items: center;
		justify-content: space-around;
		.print {
			width: 24px;
			height: 27px;
			background-image: url('../../../../assets/print.png');
			background-size: 100% 100%;
			cursor: pointer;
		}
		.derive {
			width: 24px;
			height: 22px;
			background-image: url('../../../../assets/derive.png');
			background-size: 100% 100%;
			cursor: pointer;
		}
	}
	.body {
		.logo {
			position: relative;
			top: 10px;
			right: 0;
			left: 0;
			bottom: 0;
			z-index: 100;
			.logo-img {
				max-height: 140px;
				max-width: 100%;
			}
		}

		.ques_box {
			padding: 20px 50px 50px 50px;
			box-sizing: border-box;
			width: 100%;
			// font-weight: bold;
			font-style: normal;
			font-size: 16px;
			.header {
				font-size: 20px;
				border-bottom: 3px solid blue;
				padding: 20px 0 20px 0;
				margin-bottom: 33px;
				.welcome-words {
					font-size: 16px;
					color: #666666;
					margin-top: 20px;
				}
				.info {
					display: flex;
					justify-content: space-between;
					align-items: center;
					font-weight: 100;
					font-size: 16px;
					margin-top: 20px;
					.info_num span + span {
						display: inline-block;
						margin-left: 10px;
					}

					.info_time_box {
						display: flex;
						align-items: center;
						// .progress_box{
						//     display: flex;
						//     align-items: center;
						//     margin-left: 20px;
						//     .progress{
						//         width: 150px;
						//     }
						// }
					}
				}
				.title {
					word-break: break-all;
					display: flex;
				}
			}
			.list {
				margin-bottom: 50px;
			}
			.ques_list {
				.ques_list_item {
					margin-top: 10px;
					margin-bottom: 50px;
					.input_box {
						margin-top: 10px;
					}
				}
				.title {
					// width: 100px;
					word-break: break-all;
					display: flex;
				}
				.input {
					width: 220px;
				}
			}
		}
	}

	.pageHeaderText {
		background-color: #eff4fe;
		text-align: left;
		font-size: 16px;
		color: #666666;
		padding: 12px 40px;
	}
}
.required::before {
	content: '*';
	color: #f56c6c;
	margin-right: 4px;
}
.selected {
	border: 1px solid #bae4f6 !important;
	background: #e8fbff;
	color: #2196f3;
}
.itemC {
	display: flex;
	align-items: center;
}
.btn-box {
	display: flex;
	justify-content: space-between;
	flex-direction: row-reverse;
	align-items: center;
}
.no-more {
	font-size: 16px;
	color: #a1a1a1;
	margin-bottom: 20px;
	text-align: center;
}
.share {
	background-color: #fff;
	border-radius: 5px;
	padding: 20px 15px;
	position: fixed;
	top: 50px;
	transform: translateX(930px);
	.title {
		text-align: center;
		font-size: 12px;
	}
}

/deep/.input__err > .el-input__inner {
	border-color: #f56c6c;
}
/deep/.input__err .el-textarea__inner {
	border-color: #f56c6c;
}
.input_box {
	.signature {
		width: 438px;
		border: 1px solid rgba(0, 0, 0, 0.1);
		margin: 20px 0;
		.save-signature {
			width: 100%;
			height: 40px;
			line-height: 40px;
			background: #fff;
			border-top: 1px solid rgba(0, 0, 0, 0.1);
			color: #aaa;
			font-size: 12px;
			padding: 0 10px;
			box-sizing: border-box;
			display: flex;
			justify-content: space-between;
		}
	}
	.upload-demo {
		width: 100%;
		margin-top: 20px;
	}
}

.countDown-box {
	position: absolute;
	opacity: 0;
}
</style>
<style lang="scss">
.test_question {
	.title {
		display: flex;
		width: 100%;
		// .htmlClickImgEnlarge div{
		// 	p:nth-child(1){
		// 		display: inline;
		// 	}
		// }
	}
}
.input_box {
	position: relative;

	.form-item__error {
		color: #f56c6c;
		font-size: 12px;
		line-height: 1;
		padding-top: 4px;
	}
	/deep/.input__err .el-input__inner {
		border-color: #f56c6c;
	}
	/deep/.input__err .el-textarea__inner {
		border-color: #f56c6c;
	}
}
.report-box {
	display: flex;
	justify-content: space-between;
	align-items: center;
	font-size: 12px;
	color: #707070;
	margin-top: 10px;
	margin-top: 30px;
	.right {
		opacity: 0;
	}
	.report {
		display: inline-block;
	}
	.support{
		width: 100%;
		text-align: center
	}
}
</style>
